import Proxy from './Proxy';

class ColumnSettingProxy extends Proxy {

  constructor(parameters = {}) {
    super('api/common/column-settings', parameters);
  }

  /**
   * 컬럼 설정 리스트
   * @param pageType
   * @returns {Promise}
   */
  findAllByUserIdAndPageType(pageType) {
    return this.submit('get', `${this.endpoint}/${pageType}`);
  }

  /**
   * 컬럼 설정 등록
   * @param pageType
   * @param columnSettingParam
   * @returns {Promise}
   */
  createColumnSetting(pageType, columnSettingParam) {
    return this.submit('post', `${this.endpoint}/${pageType}`, columnSettingParam);
  }

}

export default ColumnSettingProxy;
